var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonhub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3010_18515)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47135 1.79191C9.52132 1.7694 9.57556 1.75781 9.63037 1.75781H18.3696C18.4244 1.75781 18.4786 1.7694 18.5287 1.79191L24.415 4.44256C24.4838 4.47343 24.542 4.52368 24.5828 4.58713L27.938 9.81128C28.0298 9.95443 28.0188 10.1408 27.9106 10.2719L14.2994 26.7647C14.1439 26.953 13.8561 26.953 13.7007 26.7647L0.0894265 10.2719C-0.0187688 10.1408 -0.0298828 9.95443 0.0620689 9.81128L3.41717 4.58713C3.45801 4.52368 3.51624 4.47343 3.58483 4.44256L9.47135 1.79191Z",
    fill: "url(#paint0_linear_3010_18515)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47135 1.79191C9.52132 1.7694 9.57556 1.75781 9.63037 1.75781H18.3696C18.4244 1.75781 18.4786 1.7694 18.5287 1.79191L24.415 4.44256C24.4838 4.47343 24.542 4.52368 24.5828 4.58713L27.938 9.81128C28.0298 9.95443 28.0188 10.1408 27.9106 10.2719H0.0894265C-0.0187688 10.1408 -0.0298828 9.95443 0.0620689 9.81128L3.41717 4.58713C3.45801 4.52368 3.51624 4.47343 3.58483 4.44256L9.47135 1.79191Z",
    fill: "url(#paint1_linear_3010_18515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 6.9502L19.3105 13.9671H8.68994L14.0002 6.9502Z",
    fill: "#95B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6831 26.726C13.8458 26.9226 14.149 26.9186 14.3064 26.7178L15.7999 24.8135L19.3105 13.9688H8.68994L12.0998 24.8135L13.6831 26.726Z",
    fill: "url(#paint2_linear_3010_18515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0011 6.94938L4.5874 5.55566L8.69084 13.9664L14.0011 6.94938Z",
    fill: "#D7D6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0898438 10.2728L4.58655 5.55566L8.68999 13.9664L0.0898438 10.2728Z",
    fill: "#BDB3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 6.94938L23.4141 5.55566L19.3107 13.9664L14.0005 6.94938Z",
    fill: "#6E97FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9106 10.2728L23.414 5.55566L19.3105 13.9664L27.9106 10.2728Z",
    fill: "#A4CCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9107 10.2747L23.4141 5.55756L24.4279 4.45215C24.4469 4.46193 24.5025 4.48596 24.5586 4.55531C24.6308 4.64431 26.7372 7.76915 27.938 9.81422C28.0482 10.0017 27.9922 10.1765 27.9107 10.2747Z",
    fill: "#799FF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0893121 10.2747L4.58583 5.55756L3.57208 4.45215C3.55298 4.46193 3.49751 4.48596 3.44127 4.55531C3.36908 4.64431 1.26274 7.76915 0.0618594 9.81422C-0.0482356 10.0017 0.00780944 10.1765 0.0893121 10.2747Z",
    fill: "#B28DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14368 15.4096C6.10597 15.4273 6.06969 15.3829 6.09467 15.3496L7.3004 13.7415C7.65433 13.2694 7.71883 12.6409 7.46787 12.107L6.61342 10.2885C6.59575 10.2509 6.6403 10.2147 6.67364 10.2397L8.28508 11.4429C8.75823 11.7961 9.38793 11.8604 9.92292 11.61L11.7451 10.7574C11.7829 10.7397 11.819 10.7842 11.7942 10.8174L10.5884 12.4255C10.2344 12.8978 10.17 13.5261 10.4209 14.0601L11.2753 15.8785C11.293 15.9161 11.2485 15.9523 11.2151 15.9274L9.60365 14.7242C9.13059 14.3709 8.5008 14.3066 7.96581 14.557L6.14368 15.4096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3010_18515",
    x1: -0.000055459,
    y1: 10.4399,
    x2: 28.6999,
    y2: 10.1393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9889FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495027,
    stopColor: "#68A3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3010_18515",
    x1: 3.39997,
    y1: 4.45224,
    x2: 24.0999,
    y2: 4.35203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B69EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BB7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3010_18515",
    x1: 14.0002,
    y1: 13.9688,
    x2: 14.0002,
    y2: 26.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3C9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D2F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3010_18515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonhub);
export default __webpack_public_path__ + "static/media/tonhub.9e597d7a47f5d5d10c92c151d4dd1244.svg";
export { ForwardRef as ReactComponent };